$(document).ready(function(){


        $('.product-single__photo').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: false,
      asNavFor: '.product-single__thumbnails',
      infinite: true,
      responsive: [
        {
          breakpoint: 749,
          settings: {
            dots: true,
            arrows: false,
          },
        },
      ],
    });
    $('.product-single__thumb').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      vertical: false,
      verticalSwiping: false,
      asNavFor: '.product-single__photo',
      dots: false,
      focusOnSelect: true,
      infinite: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 1080,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 525,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });
  
  /*$('form[action="/cart/add"]').on('submit', function(e){
  	e.preventDefault();
    var form = $(this);
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        if(jqXHR) {
          var response = $.parseJSON(jqXHR.responseText);
          form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        }
       // btn.val('Add to cart');
      //  btn.removeAttr('disabled');
      },
      success: function() {
        window.location= '/cart';
      }
    })
  });*/
  
  $.fn.isOnScreen = function(){
    var win = $(window);
    var viewport = {
      top : win.scrollTop(),
      left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();
    var bounds = this.offset();
    if(bounds) {
      bounds.right = bounds.left + this.outerWidth();
      bounds.bottom = bounds.top + this.outerHeight();
      return (!(viewport.bottom < bounds.top || viewport.top > bounds.bottom));
    }
  };
  if($(window).width() < 750)
  {
    //$('.top-scroll').addClass("scroll_fixed");
    if($('.checkout_btn').isOnScreen()){
      //$('.top-scroll').addClass("scroll_fixed");
      $('.btn_checkout').addClass('fixed');
      $('.top-scroll').removeClass("scroll_fixed");
    }
    else{
      //$('.top-scroll').removeClass("scroll_fixed");
      $('.btn_checkout').removeClass('fixed');
      $('.top-scroll').addClass("scroll_fixed");
    }
    $( window ).scroll(function(){
      if($('.checkout_btn').isOnScreen()){
        //$('.top-scroll').addClass("scroll_fixed");
        $('.btn_checkout').addClass('fixed');
        $('.top-scroll').removeClass("scroll_fixed");
      }
      else{
     	//$('.top-scroll').removeClass("scroll_fixed");
        $('.btn_checkout').removeClass('fixed');
        $('.top-scroll').addClass("scroll_fixed");
      }
    });
  }
  // ----- add to cart button sticky
  if($('.product-form__cart-submit ,.sold_out_notify').isOnScreen()){
      //$('.top-scroll').addClass("scroll_fixed");
      $('.product-form__cart-submit ,.sold_out_notify').addClass('fixed');
      $('.sticky_btn').removeClass("scroll_fixed");
    }
    else{
      //$('.sticky_btn').removeClass("scroll_fixed");
      $('.product-form__cart-submit ,.sold_out_notify').removeClass('fixed');
      $('.sticky_btn').addClass("scroll_fixed");
    }
    $( window ).scroll(function(){
      if($('.product-form__cart-submit ,.sold_out_notify').isOnScreen()){
        //$('.sticky_btn').addClass("scroll_fixed");
        $('.product-form__cart-submit ,.sold_out_notify').addClass('fixed');
        $('.sticky_btn').removeClass("scroll_fixed");
      }
      else{
     	//$('.sticky_btn').removeClass("scroll_fixed");
        $('.product-form__cart-submit ,.sold_out_notify').removeClass('fixed');
        $('.sticky_btn').addClass("scroll_fixed");
      }
  });
  function refreshCart(cart) {
    $('span.cartCount').text(cart.item_count);
     if($('body').attr('data-product') != '' || $('body').attr('data-product') !== 'undefined'){
          var get_product = $('body').attr('data-product');
          var get_price = parseInt($('body').attr('data-price_limit')*100);
          var get_value = true;
          for(var i=0;i<cart.items.length;i++){            
            if(cart.items[i].id ==  get_product ){
             var get_value = false; 
            }
          }                    
           if(cart.total_price > get_price ){
             if(get_value ){               
                  $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data:{id:get_product, quantity:1},
                    dataType: 'json',
                    success: function(item) { 
                       $.getJSON('/cart.js', function(cart){                      
                      $('span.cartCount').text(cart.item_count);  
                       });
                      if($('body').hasClass('template-cart')){
                        location.href = "/cart";
                      }
                    }          
                });               
               }
              } 
        }
  }
  function formSuccess(form,btn)
  {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        if(jqXHR) {
          var response = $.parseJSON(jqXHR.responseText);
          form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        }
      },
      success: function(item) {
        $.getJSON('/cart.js', function(cart){
          refreshCart(cart);
        });
        btn.val('Add to cart');
        btn.attr('disabled','disabled');
        if($('.itemaddCart').length == 0){
          $('.product-form__item--submit .itemaddCart').remove();
          var escapedMessage = theme.strings.added_to_cart_message;
          var decodedMessage = $('<textarea/>').html(escapedMessage).text();
          $('.product-form__item--submit').append('<p class="itemaddCart">' + decodedMessage + '</p>');

        }else{
        }
        // pintrk('track', 'addtocart', {
        //   value: item.price/100,
        //   order_quantity: form.find('[name="quantity"]').val(),
        //   currency: Shopify.currency.active
        // });
        
        btn.removeAttr('disabled');
      }
    })
  }
  $('form[action="/cart/add"]').on('submit', function(e){
    e.preventDefault();


    $('.post_card_error').remove();
    var btn = $(this).find('.product-form__cart-submit');
    var form = $(this);
    btn.attr("disabled", true);
    if($('#personalizeContent:visible').length >0){
      var x = true;
      $(this).find('.err-msg').remove();
      var name = $(this).find('#your-message');
      var size = $(this).find('#text-size');
      var font = $(this).find('#font-type');
      // var font = $(this).find('.properties_box input:checked');
      console.log(font,"name");
      if(name.val().trim() == ''){
        name.parent().append('<p class="err-msg">Please enter Your Message.</p>');
        x = false;
      } else {
        name.parent().find('.err-msg').remove();
      }
      if(size.val() == '' || size.val() == 'Please select'){
        size.css('border-bottom','1px solid red');
        size.parent().append('<p class="err-msg">Please Select Text Size.</p>');
        x = false;
      } else {
        size.css('border-bottom','1px solid #000');
        size.parent().find('.err-msg').remove();
      }
      if(font.val() == '' || font.val() == 'Please select'){
        font.css('border-bottom','1px solid red');
        font.parent().append('<p class="err-msg">Please Select Font Type.</p>');
        x = false;
      } else {
        font.css('border-bottom','1px solid #000');
        font.parent().find('.err-msg').remove();
      }
      if(x==false) {
        return false;
      }
      else{
        formSuccess(form,btn);
      }
    }
    else if($('#post_card_msg').length > 0 && $.trim($('#post_card_msg').val()).length > 150){
        $('.post_cart_engrave_wrapper').append('<p class="post_card_error">You can not add characters more than 150.</p>')
      }
    else
    {
      formSuccess(form,btn);
    }
  });
    $('body').on('click','#MobileNav .mobile-sec button', function(e){   
    e.preventDefault();
    //console.log('im in');
    $(this).parent().parent().find('.sub-sub-menu').addClass('is-active');
  });

  $('body').on('click','#MobileNav .third_return button', function(e){   
    e.preventDefault();
    $(this).closest('.sub-sub-menu').removeClass('is-active');
  });

  window.onload = function(){
    $('.loadImg').each(function(){
      $(this).attr('src', $(this).attr('data-src'));
    });
  };
  /* COLLECTION FORM START */	
  var original_pswd = CryptoJS.AES.encrypt('wildthings-collectables', "Ngodeinweb");
  $('body').attr('original',original_pswd.toString());

  $('#col_sub').on('click',function(e){
    e.preventDefault();
    var f = true;

    var old_pswd = CryptoJS.AES.decrypt($('body').attr('original'), "Ngodeinweb"); 
    var pswd = $(this).parents('.collectionform').find('#coll_pswd');

    if(pswd.val().trim() == '' || pswd.val() != old_pswd.toString(CryptoJS.enc.Utf8)) {
      if(pswd.val() == ''){
        var message = "Please Enter password";
      }else {
        message = "Invalid Password";
      }
      pswd.parents('.collectionform').find('.col-form-error').text(message).css('display','block');
      f = false;
      e.preventDefault();
    } else {
      pswd.parents('.collectionform').find('.col-form-error').text(message).css('display','none');
    } 

    if(f == false) {
      return false;
    }
    else {
      setCookie("collection_password", "1", 7);
      //       alert('matched');
    }
  })
  /* COLLECTION FORM END */	
});



var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
var player;

// function remove_class(element,event){
//   console.log(event.data);
//   if(event.data === 1){
//     element.classList.remove("no-js");
//   }else{
//     setTimeout(function(){ remove_class(element,event); }, 1000);
//   }
// }

function onYouTubeIframeAPIReady() {
  $('.videoFrame').each(function(i,v){
    var video_id = $(this).attr('data-videopp-id');
    var sec_id = $(this).attr('id');
    var autoplay = 1;
    var loop = 1;
    autoplay = parseInt(autoplay);
    var parent_id = $(this).attr('data-parent');
    var player;
    player = new YT.Player(sec_id, {
      height: '680',
      width: '1920',
      videoId: video_id,
      playerVars: {
        autohide: 0,
        branding: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 1,
        loop: 1,
        iv_load_policy: 3,        
        playsinline: 1,
        quality: 'hd720',
        enablejsapi: 1,
        modestbranding: 1,
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'                
      },
      events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
      }
    });
    function onPlayerReady(event) {
      event.target.mute();
      event.target.playVideo();
    }
      function onPlayerStateChange(event) {
        setInterval(function() {
          if(player.getCurrentTime() > 0){
           // console.log(player.getCurrentTime());
            var element = document.getElementById(parent_id);
            element.classList.remove("poster_get");
          }
        }, 1000);
        if (event.data == YT.PlayerState.ENDED || event.data == YT.PlayerState.PAUSED) {
          //player.stopVideo();
          // alert($(".hero__media").contents().find(".ytp-pause-overlay").length);
          $(".hero__media").contents().find(".ytp-pause-overlay").remove();
        }
      if (event.data == YT.PlayerState.ENDED) {  
        player.seekTo(0);
        player.playVideo();
      }
    }
  });
  
  $('.video-wrapper_campaign').each(function(i,v){
    var video_id = $(this).attr('data-video_id');
    var sec_id = $(this).attr('id');
    var autoplay = 0;
    var loop = 1;
    
    autoplay = parseInt(autoplay);
    var player;
    player = new YT.Player(sec_id, {
      height: '680',
      width: '1920',
      videoId: video_id,
      playerVars: {
        autohide: 0,
        branding: 0,
        cc_load_policy: 0,
        controls: 1,
        fs: 1,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 1,
        showinfo: 1,
        wmode: 'opaque'
      },
      events: {
        'onReady': onPlayerReady_not_auto,
        'onStateChange': onPlayerStateChange_not_auto
      }
    });
    function playvideo(event) {
      console.log('imin function');
      event.target.playVideo();
    }
    function onPlayerReady_not_auto(event) {
//       event.target.mute();
    }
    function onPlayerStateChange_not_auto(event) {
      if (event.data == YT.PlayerState.ENDED) {  
        player.seekTo(0);
        player.playVideo();
      }
    }
  });
  
  
}


$("body").on("click",".megamenu-main-link.menu_li",function(){
  var href = $(this).find("a").attr("href");
  if(href!= '#'){
    window.location.assign(href);
  }
});

$('.faq-wrap h4').click(function(){
  if($(this).hasClass('openFaq')){
    $(this).removeClass('openFaq');
    $(this).next('.faqAnswer').slideUp();
  }else {
    $('.faq-wrap h4').removeClass('openFaq');
    $('.faqAnswer').slideUp();
    $(this).addClass('openFaq');
    $(this).next('.faqAnswer').slideDown();
  }
});
// $( document ).ready(function() {
//   $("body").on("click",".refer_click ,.collect-credit-box,.my-point-box-wrp",function(e){
//   e.preventDefault();
//   $('.lion-loyalty-widget__body').trigger('click');
// });
// });


//banner video
// setTimeout(function() {
//     $('#img-vid')[0].play();
//     $('.video_poster_img').attr('data-click', 1)
//     $(".video_poster_img").css("opacity", "0");
// }, 5000);
// $('.video_poster_img').on('click',function(){
//     if($(this).attr('data-click') == 1) {
//       $(this).attr('data-click', 0)
//       $('#img-vid')[0].pause();
//       $(".video_poster_img").css("opacity", "1");
//     } else {
//       $(this).attr('data-click', 1)
//       $('#img-vid')[0].play();
//       $(".video_poster_img").css("opacity", "1");
//       $(".video_poster_img").css("opacity", "0");
//     }
// });
// our step slider
const our_step_slider = $('.our_step_inner').slick({
  dots: true,
  arrows:false,
  slidesToShow: 4,
  infinite: true,
  slidesToScroll: 1,
  touchThreshold: 10,
  autoplay: true,
  autoplaySpeed: 2000,
  prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="15px" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="15px" xml:space="preserve"><polygon points="160,115.4 180.7,96 352,256 180.7,416 160,396.7 310.5,256 "/></svg></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="15px" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="15px" xml:space="preserve"><polygon points="160,115.4 180.7,96 352,256 180.7,416 160,396.7 310.5,256 "/></svg></button>',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint:640,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint:480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
our_step_slider.on('wheel', (function(e) {
  e.preventDefault();

  if (e.originalEvent.deltaY < 0) {
    $(this).slick('slickPrev');
  } else {
    $(this).slick('slickNext');
  }
}));

//faq accordion
$(".lists_col:first-child").addClass('active').find(".faq-accordion-values").slideDown();;
    $(".faq-accordion-inner").click(function () {
        $(this).parent(".lists_col").toggleClass('active').find(".faq-accordion-values").slideToggle();
        $(this).parent(".lists_col").prevAll(".lists_col").removeClass('active').find(".faq-accordion-values").slideUp();
      // $('.faq-accordion-values').removeClass('active');
        $(this).parent(".lists_col").nextAll(".lists_col").removeClass('active').find(".faq-accordion-values").slideUp();
    });
$(document).ready(function(){
  $('.collect-credit-wrp').click(function(){
    $(this).addClass('current');
    // $(this).closest('.button_box_wpr').addClass('current');
    
  });
  $('.close_box').click(function(){
    $('.collect-credit-wrp').removeClass('current');
    console.log($(this).parents('.button_box_wpr').removeClass('current'),"")
  });

  // ----sticky add to cart btn
 $('.sticky_btn .add_tocart_btn_click').click(function(){
   console.log("add to cart click")
   $('form[action="/cart/add"]').trigger( "submit" );
      
        if($('.itemaddCart').length == 0){
          $('.addto_sticky_btn .itemaddCart').remove();
          var escapedMessage = theme.strings.added_to_cart_message;
          var decodedMessage = $('<textarea/>').html(escapedMessage).text();
          $('.addto_sticky_btn').append('<p class="itemaddCart">' + decodedMessage + '</p>');

        }else{
        }
   });


 // Sticky Filter & Category
  function filterSticky() {
      if ($(window).width() < 768) {
          var HeaderHeight = $('header.site-header').outerHeight();
          var announcebarHeight = $('.notification-bar').outerHeight();
          var totleHeight = HeaderHeight + announcebarHeight;

          $('.sub-colle').css({'top': totleHeight + "px"});
      }
  }
  filterSticky();
  $(window).resize(function () {
      filterSticky();
  });

});
// -------- variant option trigger click 
 $('.option_selector li').click(function(){
   var valueget =  $(this).attr('option-value');
   if (valueget == "Without engraving") {
     $('#personalizeContent').hide();
   } else {
     $('#personalizeContent').show();
   }
   $(".option_selector li").removeClass("option_active");
   $(this).addClass('option_active');
   $('.price_option_text span').html("(" + valueget + ")");
var $el = $('.product-form__input option[value="' + valueget + '"]');
$el.prop('selected',true);
$el.trigger("change");
});


$(document).ready(function () {
  
$('body').on('click', '.colle_product_tag', function () {
    $('.colle_product_tag').removeClass('active');
    $(this).addClass('active');
    
    var tagurl = $(this).attr('data-tag').toLowerCase();
    if (tagurl) {
        $('.filter-group-display__list.product_type .filter-group-display__list-item').each(function () {
            var $input = $(this).find('input[name="filter.p.product_type"]');
            var product_val = $input.val().toLowerCase(); // Convert to lowercase

            // Uncheck all inputs first
            $input.prop('checked', false);

            // Check if product_val contains tagurl
            if (product_val.includes(tagurl)) {
                $input.prop('checked', true).trigger('change'); // Ensure change event is triggered
            }
        });

        // Click the filter submit button
        $('.filter-group-display__submit .btn-apply').click();

        // Clear the URL after "?"
        if (window.history.pushState) {
            var url = window.location.origin + window.location.pathname;
            window.history.pushState({ path: url }, '', url);
        }
    }
});

    // Get all checked filter inputs
    var selectedTags = [];

    $('input[name="filter.p.product_type"]:checked').each(function () {
        selectedTags.push($(this).val().toLowerCase()); // Store checked values in lowercase
    });

    console.log(selectedTags, "Selected Filters");

    // Loop through the tag list and add 'active' class if any tag matches partially
    $('.tag-filters .colle_product_tag').each(function () {
        var tagurl = $(this).attr('data-tag-url').toLowerCase(); // Convert data-tag-url to lowercase

        // Check if any selected filter contains the tagurl (partial match)
        var isMatch = selectedTags.some(product_val => product_val.includes(tagurl));

        if (isMatch) {
            $(this).addClass('active'); // Add active class if a match is found
        }
    });



  // $(".colle_product_tag").each(function() {
  //   var tagurl =  $(this).attr('data-tag-url');
  //   url = window.location.href;
  //   if( url.match(tagurl) ) {
  //     var tagurlva = $('.colle_product_tag[data-tag-url="'+tagurl + '"]');
  //     tagurlva.addClass("active");    
  //   } else{
  //     var tagurlva = $('.colle_product_tag[data-tag-url="'+tagurl + '"]');
  //     tagurlva.removeClass("active");    
  //   }
  // });
  
  // if($('body').hasClass('collectionHadle-earrings')){
  //   $('.colle_product_tag').click(function(){    
  //     var valuegett =  $(this).attr('data-tag');
  //     if($(this).hasClass('active')){
  //       $(this).removeClass('active');
  //     }else{
  //       $(this).addClass('active');
  //     }
  //     var tiggercheckbox = $('.boost-pfs-filter-option-item span[aria-labelledby="'+valuegett + '"]');    
  //     tiggercheckbox.parents(".boost-pfs-filter-option-item").trigger( "click" );
  //     $(".boost-pfs-filter-apply-button").trigger( "click" );
  //   });
  
  //   function filterCheck(){
  //     console.log('filterCheck ==')
  //     $(".colle_product_tag").each(function() {
  //       var tagurl =  $(this).attr('data-tag-url');
  //       url = window.location.href;
  //       if( url.match(tagurl) ) {
  //         var tagurlva = $('.colle_product_tag[data-tag-url="'+tagurl + '"]');
  //         tagurlva.addClass("active");    
  //       } else{
  //         var tagurlva = $('.colle_product_tag[data-tag-url="'+tagurl + '"]');
  //         tagurlva.removeClass("active");    
  //       }
  //     });
  //   }
  //   filterCheck();
   
  //   function got_boost_length(){
  //     if($('button.boost-pfs-filter-button.boost-pfs-filter-clear').length){
  //       $('button.boost-pfs-filter-button.boost-pfs-filter-clear, button.boost-pfs-filter-button.boost-pfs-filter-clear-all, button.boost-pfs-filter-button.boost-pfs-filter-apply-button').click(function(){        
  //         filterCheck();
  //       })      
  //       setTimeout(function(){ got_boost_length(); }, 500);
  //     }else{
  //      setTimeout(function(){ got_boost_length(); }, 500);
  //     }
  //   }
  //   got_boost_length();
  // }

  /* Predictive search : Start */
  $(".search__input").on('input', function() {
    var $this = $(this);
    let searchTerm = $(this).val();    
    if( searchTerm ){
      $('.prediactive_search').show();
      
      $.get(`${window.routes.predictive_search_url}?q=${searchTerm}&section_id=predictive-search`, function(data) {        
        $this.closest("form").find('.prediactive_search').html($(data).html());
      });
    }
  });
  $(document).on('click', function(event) {
    if (!$(event.target).closest('.prediactive_search').length) {
      $('.prediactive_search').hide();
    }
  });
  $('.prediactive_search').on('click', function(event) {
    event.stopPropagation();
  });
 /* Predictive search : End */ 
    
});



// properties drop-down tigger click
 $('.properties_box input').click(function(){
 $(".properties_box input").prop('checked', false);
   $(this).prop('checked', true);
   var fontvalue =  $(this).val();
    $('#personalizeContent p.err-msg').hide();
   $(".product-form__cart-submit").prop('disabled', false);
  var $ell = $('.hide_properties_box option[value="' + fontvalue + '"]');
  $ell.prop('selected',true);
  $ell.trigger("change");
   
});

//--------- Notify btn tigger click 
$('.sticky_btn .notify_btn_click').click(function(){
  console.log("Notify ")
 $( "a.btn.klaviyo-bis-trigger" ).trigger( "click" );
});

// -------category-dropdown js for collection page
$('.category-dropdown h3').click(function () {
    $('.category-dropdown ul').slideToggle();
});
$(window).load(function() {
$('.boost-pfs-filter-tree-mobile-button button').text(filtertitle);
});
$('.filter_close').click(function () {
  $( ".boost-pfs-filter-tree-mobile-button" ).trigger( "click" );
  });
$(window).resize(function(){
 var HeaderHeight = $('.siteMainHeader').outerHeight();
  console.log(HeaderHeight,"HeaderHeight");

   $( '.main-content' ).css( {
      'padding-top': HeaderHeight + "px"
  });
});
  

  $('.Split-image_col').on('click', function(e) {
    var targetId = $(this).data('scroll');
    var $target = $('#' + targetId);
    
    // Only intercept if data-scroll is not blank and target element exists
    if (targetId && $target.length) {
      e.preventDefault();

      var headerHeight = $('.site-header').outerHeight() || 0;

      $('html, body').animate({
        scrollTop: $target.offset().top - headerHeight
      }, 800);
    }
    // Else: allow default anchor behavior (e.g., href redirect from Liquid)
  });